import { useContext, useState } from 'react'

import { Onboarding } from '@hhgtech/hhg-components/onboardingV2'
import { useIntl } from 'react-intl'

import { callApiNew } from 'api/axios'
import { PATHS } from 'api/paths'
import { postSSOApiFormData } from 'api/utils'
import { showNotification } from 'components/molecules/notificationsHandler'
import ErrorBoundary from 'components/templates/navigatorLayout/errorBoundary'
import { actionTypes } from 'state/actionTypes'
import { AppContext } from 'state/appContext'

export type Props = {
  isSkippable?: boolean
  isWhatsApp?: boolean
  onClose?: () => void
}

const OnboardingModal = ({
  isSkippable,
  isWhatsApp,
  onClose = () => false,
}: Props) => {
  const { formatMessage: f } = useIntl()
  const { dispatch } = useContext(AppContext)

  const onResendCode = async (phone: string) => {
    if (!phone) return
    try {
      const response = await postSSOApiFormData(
        isWhatsApp
          ? PATHS.SSO.SEND_OTP_VIA_WHATSAPP
          : PATHS.LEADGEN.POST_LEAD_SEND_OTP,
        {
          phone_number: phone.startsWith('+') ? phone : `+${phone}`,
        },
      )
      /**
        - This phone number was verified
        - Send sms successfully
        - Send sms Fail
        - SMS OTP not support your country
        */
      const respMessage =
        typeof response?._messages === 'string'
          ? response._messages
          : response?._messages?.[0]

      const errorList = [
        'SMS OTP not support your country',
        'Send sms Fail',
        `User don't update`,
        'Some Things Went Wrong',
      ]

      if (errorList.includes(respMessage)) {
        const defaultError = f({ id: 'notification.comment.somethingWrong' })
        showNotification({
          title:
            (respMessage.includes(`User don't update`)
              ? f({
                  id: 'onboarding.noti.linkedToAnotherAccount',
                  defaultMessage:
                    'This phone number has been linked to another account.',
                })
              : errorList.includes('Some Things Went Wrong')
              ? defaultError
              : respMessage) || defaultError,
          message: '',
          type: 'danger',
        })
        return respMessage
      }
      return undefined
    } catch (_) {
      const error = f({ id: 'notification.comment.somethingWrong' })
      showNotification({
        title: error,
        message: '',
        type: 'danger',
      })
      console.error(error)
      return error
    }
  }
  const [otpError, setOtpError] = useState<string>()
  const onOtpSubmit = async (otp: string) => {
    setOtpError(undefined)
    try {
      const res = await postSSOApiFormData(
        isWhatsApp
          ? PATHS.SSO.VERIFY_OTP_VIA_WHATSAPP
          : PATHS.SUBOT.POST_VERIFY_SMS_OTP,
        {
          otp_code: otp,
        },
        { method: 'POST' },
      )
      // - Wrong Phone Number
      // - This phone number was verified
      // - Verify successfully
      // - Verify OTP failed
      // - SMS OTP not support your country
      const respMessage = res?._messages[0]
      if (respMessage === 'Verify sucess' || res?._status === 1) {
        showNotification({
          title: f({
            id: 'subot.verifyOTP.success.message',
            defaultMessage: 'Verified successful',
          }),
          message: '',
          type: 'success',
        })
        const user = await callApiNew(
          PATHS.USER_PROFILE.GET_PROFILE,
          {
            method: 'POST',
          },
          'sso',
        )
        if (user?._data?.id)
          dispatch({
            type: actionTypes.LOGIN,
            payload: user?._data,
          })
        onClose()
      } else if (respMessage === 'This phone number was verified') {
        showNotification({
          title: 'This phone number was verified',
          message: '',
          type: 'success',
        })
        const user = await callApiNew(
          PATHS.USER_PROFILE.GET_PROFILE,
          {
            method: 'POST',
          },
          'sso',
        )
        if (user?._data?.id)
          dispatch({
            type: actionTypes.LOGIN,
            payload: user?._data,
          })
        onClose()
      } else {
        const error = f({ id: 'notification.comment.somethingWrong' })
        setOtpError(error)
        return error
        // showNotification({
        //   title: res?._messages[0] || defaultError,
        //   message: '',
        //   type: 'danger',
        // })
      }
    } catch (error) {
      console.error(error)
      const defaultError = f({ id: 'notification.comment.somethingWrong' })

      showNotification({
        title: defaultError,
        message: '',
        type: 'danger',
      })
      onClose()
    }
    return undefined
  }

  return (
    <>
      <ErrorBoundary>
        <Onboarding.Provider>
          <Onboarding.Modal withPortal>
            <Onboarding.StepRenderer>
              <Onboarding.Form
                isWhatsApp={isWhatsApp}
                customFormTexts={
                  !isWhatsApp
                    ? {
                        description: f({
                          id: 'onboarding.updatePhone.description.v2',
                          defaultMessage:
                            'We will send a One-Time Password (OTP) to your phone number',
                        }),
                      }
                    : undefined
                }
                onClose={onClose}
                canSkip={isSkippable}
                onSubmit={onResendCode}
                alwaysRender
              />
              <Onboarding.OtpForm.Phone
                isWhatsApp={isWhatsApp}
                onSubmit={onOtpSubmit}
                onResendCode={onResendCode}
                otpError={otpError}
                onClose={onClose}
                canSkip={isSkippable}
              />
            </Onboarding.StepRenderer>
          </Onboarding.Modal>
        </Onboarding.Provider>
      </ErrorBoundary>
    </>
  )
}

export default OnboardingModal
